module.exports = __webpack_public_path__ + "svg/flags/Venezuela, Bolivarian Republic of.svg";